import * as t from 'io-ts'

export const LinkDecoder = t.type({
  label: t.string,
  url: t.string,
})
